import axios from 'axios'

export default async function createModelMember(path, Model, modelParams = {}) {
  const idParamName = `${Model.singularCamelName}Id`
  const attributesParamName = `${Model.singularCamelName}Attributes`

  return axios
    .post(`${path}.json`, {
      [Model.singularCamelFullName]: modelParams[attributesParamName]
    })
    .then(({ data }) => {
      const instance = new Model(data[Model.singularCamelFullName])
      return { ...data, [Model.singularCamelFullName]: instance }
    })
}
